import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { http } from "@/lib/api";

export default function ConfirmSectorSubscription() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [sector, setSector] = useState(null);
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    http.get(`/sector-subscribers/confirm?token=${encodeURIComponent(token)}`)
      .then((r) => { setState("ok"); setSector(r.data.sector_code); })
      .catch(() => setState("error"));
  }, [params]);
  return (
    <div className="bp-container py-24 text-center max-w-xl">
      {state === "loading" && <div className="animate-pulse h-6 w-40 bg-neutral-200 mx-auto" />}
      {state === "ok" && (
        <>
          <h1 className="font-serif text-4xl mb-4">Sector subscription confirmed</h1>
          <p style={{ color: "var(--bp-text-secondary)" }}>You&apos;ll receive the {sector} quarterly digest.</p>
          <Link to="/data" className="bp-link mt-6 inline-block">Browse sector reports →</Link>
        </>
      )}
      {state === "error" && <><h1 className="font-serif text-4xl mb-4">Invalid or expired link</h1><Link to="/" className="bp-link">Back home →</Link></>}
    </div>
  );
}
